module.exports = __webpack_public_path__ + "static/img/ddcj.bfdb515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/ddcj.jpg
// module id = 1429
// module chunks = 0